import { setLoggedInSettings } from '@/stores/logged-in-settings/actions'

export const initLoggedInSettings = () => {
  const scriptTag = document.getElementById('logged-in-settings')
  if (!scriptTag) return

  const loggedInSettings = JSON.parse(scriptTag.innerHTML)
  setLoggedInSettings(loggedInSettings)
}
